import React, { useEffect, useState } from 'react';
import { buildTherapyHref, getActivePromoEvents, PromoEvent } from '../../data/events';
import './booking.css';

const MOBILE_USER_AGENT = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

interface BookingOption {
    id: string;
    date: { day: string; month: string } | null;
    badge: string;
    title: string;
    subtitle: string;
    desc: string;
    therapyLink: string | null;
}

const ALL_EVENTS: BookingOption[] = [
    {
        id: 'behandlung',
        date: null,
        badge: 'Ersttermin oder Folgebehandlung',
        title: 'Behandlung',
        subtitle: 'Standort Regensburg · Ziegetsdorfer Str. 32',
        desc: 'Ganzheitliche Naturheilkunde, individuell auf Sie abgestimmt.',
        therapyLink: null,
    },
    {
        id: 'behandlung-kelheim',
        date: null,
        badge: 'Ersttermin oder Folgebehandlung',
        title: 'Behandlung',
        subtitle: 'Standort Kelheim · Donaustr. 14',
        desc: 'Ganzheitliche Naturheilkunde, individuell auf Sie abgestimmt.',
        therapyLink: null,
    },
    {
        id: 'behandlung-regensburg-maximilianstr',
        date: null,
        badge: 'Ersttermin oder Folgebehandlung',
        title: 'Behandlung',
        subtitle: 'Standort Regensburg · Maximilianstr. 24',
        desc: 'Ganzheitliche Naturheilkunde, individuell auf Sie abgestimmt.',
        therapyLink: null,
    },
];
const EVENTS = ALL_EVENTS;
const ACTIVE_PROMO_EVENTS = getActivePromoEvents();

const Booking = () => {
    const [isMobileClient, setIsMobileClient] = useState(false);

    useEffect(() => {
        setIsMobileClient(MOBILE_USER_AGENT.test(window.navigator.userAgent));
    }, []);

    const renderContactCta = (className: string) => (
        isMobileClient ?
            <a className={className} href="tel:+491776962490">
                Rufen Sie mich an
            </a>
            :
            <a className={className} href="/#page-contact">
                Kontaktieren Sie mich
            </a>
    );

    const renderPromoCta = (event: PromoEvent) => {
        const { action } = event;

        if (action.href.startsWith('http')) {
            return (
                <a
                    className="buttonSecondary"
                    href={action.href}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {event.ctaLabel}
                </a>
            );
        }

        return renderContactCta('buttonSecondary');
    };

    return (
        <div className="section sectionBackground" id="booking">
            <div className="viewport">
                <div className="bookingItem">
                    <h1>Termin buchen</h1>
                    <p className="sectionLead">
                        Vereinbaren Sie Ihren Termin gerne telefonisch oder per E&#8209;Mail.
                        Dabei k&ouml;nnen Sie mir auch vorab kurz Ihr Anliegen schildern.
                    </p>
                    <div className="bookingCards">
                        {EVENTS.map(ev => (
                            <div key={ev.id} className="bookingCard">
                                <div className="bookingCardHeader">
                                    <span className="bookingCardBadge">{ev.badge}</span>
                                    {ev.date && (
                                        <div className="bookingCardDate" aria-label={`${ev.date.day}. ${ev.date.month}`}>
                                            <span className="bookingCardDay">{ev.date.day}</span>
                                            <span className="bookingCardMonth">{ev.date.month}</span>
                                        </div>
                                    )}
                                </div>
                                <h2 className="bookingCardTitle">{ev.title}</h2>
                                <p className="bookingCardSubtitle">{ev.subtitle}</p>
                                <p className="bookingCardDesc">{ev.desc}</p>
                                {ev.therapyLink && (
                                    <a className="bookingCardTherapyLink" href={ev.therapyLink}>
                                        Mehr zur SANZA&#8209;Methode&nbsp;→
                                    </a>
                                )}
                            </div>
                        ))}
                    </div>
                    <div className="bookingContact">
                        {renderContactCta('buttonPrimary')}
                    </div>
                    {ACTIVE_PROMO_EVENTS.length > 0 && (
                        <div className="bookingEventsSection">
                            <h2 className="bookingEventsTitle">Aktuelle Events &amp; Aktionen</h2>
                            <p className="bookingEventsLead">
                                Diese aktuell verf&uuml;gbaren Angebote und Veranstaltungen k&ouml;nnen Sie online reservieren
                                oder telefonisch anfragen.
                            </p>
                            <div className="bookingCards">
                                {ACTIVE_PROMO_EVENTS.map((event) => (
                                    <div key={event.id} className="bookingCard bookingCardHighlight">
                                        <div className="bookingCardHeader">
                                            <span className="bookingCardBadge">{event.badge}</span>
                                            {event.day && event.month && (
                                                <div className="bookingCardDate" aria-label={`${event.day}. ${event.month}`}>
                                                    <span className="bookingCardDay">{event.day}</span>
                                                    <span className="bookingCardMonth">{event.month}</span>
                                                </div>
                                            )}
                                        </div>
                                        <h3 className="bookingCardTitle">{event.title}</h3>
                                        <p className="bookingCardSubtitle">
                                            {event.time ? `${event.time} · ` : ''}Standort Regensburg
                                        </p>
                                        <p className="bookingCardDesc">{event.desc}</p>
                                        {event.moreTherapyId && (
                                            <a className="bookingCardTherapyLink" href={buildTherapyHref(event.moreTherapyId)}>
                                                Mehr zur SANZA-Methode&nbsp;→
                                            </a>
                                        )}
                                        {renderPromoCta(event)}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Booking;
